// extracted by css-extract-rspack-plugin
export default {"skipLink":"gUtHf"};